module.exports = __webpack_public_path__ + "static/video-making-vp9-6c8a35e6c1572dcb62403a6ab181e501.webm";